webpackJsonp([400],{

/***/ "/0Kg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  storeHeader: 'storeHeader',
  storeMetaData: 'storeMetaData'
});

/***/ }),

/***/ "98RI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionType__ = __webpack_require__("/0Kg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__("9vGq");



/* harmony default export */ __webpack_exports__["a"] = (function (action, actionPayload) {
  return function (dispatch) {
    switch (action) {
      case __WEBPACK_IMPORTED_MODULE_0__actionType__["a" /* default */].storeHeader:
        var _ref = actionPayload || {},
            headers = _ref.headers,
            merchantData = _ref.merchantData;

        if (merchantData) {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["f" /* WIDGET_STORE_MERCHANT_DATA */],
            payload: merchantData
          });
        }
        return dispatch({
          type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["e" /* WIDGET_STORE_HEADER */],
          payload: headers
        });
      case __WEBPACK_IMPORTED_MODULE_0__actionType__["a" /* default */].storeMetaData:
        var _ref2 = actionPayload || {},
            metadata = _ref2.metadata;

        return dispatch({
          type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["g" /* WIDGET_STORE_META_DATA */],
          payload: metadata
        });
      default:
        return null;
    }
  };
});

/***/ }),

/***/ "AohM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isParentMerchantOriginValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidParentMerchantUrl; });
var whiteListedMerchants = ['https://paiinternational.in', 'https://widget-test.instacred.dev', 'https://widget-staging.instacred.dev'];

var isMerchantUrlWhitelisted = function isMerchantUrlWhitelisted(url) {
  return whiteListedMerchants.includes(url);
};

var getWhitelistedUrl = function getWhitelistedUrl(url) {
  return whiteListedMerchants.find(function (whitelistedUrl) {
    return whitelistedUrl === url;
  });
};

var isParentMerchantOriginValid = function isParentMerchantOriginValid(postMessageOrigin) {
  var parentMerchantOrigin = document.referrer;
  var isOriginValid = parentMerchantOrigin.includes(postMessageOrigin) ? true : isMerchantUrlWhitelisted(postMessageOrigin);

  return isOriginValid;
};

var getValidParentMerchantUrl = function getValidParentMerchantUrl(postMessageOrigin) {
  var parentMerchantOrigin = document.referrer ? document.referrer : getWhitelistedUrl(postMessageOrigin);

  return parentMerchantOrigin;
};

/***/ }),

/***/ "IkrK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_services_requestService__ = __webpack_require__("q4YJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__("9vGq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_material_ui_helper__ = __webpack_require__("Ahxv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("jYI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_widgetAction__ = __webpack_require__("98RI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_widgetAction_actionType__ = __webpack_require__("/0Kg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tracking__ = __webpack_require__("Z0Lr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_controllers_widgetControllers__ = __webpack_require__("Yfrm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__("DHvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_helper__ = __webpack_require__("btDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_controllers_experimentController__ = __webpack_require__("oUNq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_merchantOriginHelper__ = __webpack_require__("AohM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__("mV6u");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */















var WidgetCommunicationScreen = function (_Component) {
  _inherits(WidgetCommunicationScreen, _Component);

  function WidgetCommunicationScreen() {
    var _temp, _this, _ret;

    _classCallCheck(this, WidgetCommunicationScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleIframeTask = function (e) {
      var isWrongDataBeingPassed = typeof e.data === 'object' ? true : !e.data.includes('dataType');

      var postMessageOrigin = e.origin;

      if (postMessageOrigin === window.location.origin && typeof e.data !== 'object' && e.data.includes('isTerminalState')) {
        _this.sendDataToParents({
          responseType: 'ntbResponse',
          response: {
            isTerminalState: JSON.parse(e.data).isTerminalState === true
          }
        });
      }

      if (e.data === '' || e.target.name !== 'instacred' || isWrongDataBeingPassed) {
        return;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_12__utils_merchantOriginHelper__["b" /* isParentMerchantOriginValid */])(postMessageOrigin)) {
        console.log('Parent merchant url is not valid');
        return;
      }

      try {
        JSON.parse(e.data);
      } catch (err) {
        throw err + ': ' + (e.data.includes('dataType') ? 'Invalid InstaCred response' : e.data) + ' ' + postMessageOrigin + ' ' + window.location.origin;
      }

      var _ref = JSON.parse(e.data) || {},
          dataType = _ref.dataType,
          requestName = _ref.requestName,
          request = _ref.request,
          merchantKey = _ref.merchantKey,
          icScope = _ref.icScope;

      icScope === 'eligibility-sdk' ? Object(__WEBPACK_IMPORTED_MODULE_7__tracking__["d" /* initializeTracker */])() : Object(__WEBPACK_IMPORTED_MODULE_7__tracking__["d" /* initializeTracker */])(null, true);

      if (dataType === 'tracking') {
        var _ref2 = request || {},
            eventType = _ref2.eventType,
            trackingData = _ref2.trackingData;

        switch (eventType) {
          case 'pageView':
            {
              var _ref3 = trackingData || {},
                  pageKey = _ref3.pageKey,
                  metadata = _ref3.metadata;

              return __WEBPACK_IMPORTED_MODULE_7__tracking__["e" /* tracker */].trackPageView(__WEBPACK_IMPORTED_MODULE_7__tracking__["b" /* PageLoadType */].DYNAMIC, pageKey, metadata);
            }
          case 'userAction':
            {
              var _ref4 = trackingData || {},
                  elementName = _ref4.elementName,
                  _pageKey = _ref4.pageKey,
                  _metadata = _ref4.metadata;

              return __WEBPACK_IMPORTED_MODULE_7__tracking__["e" /* tracker */].trackUserInteraction(__WEBPACK_IMPORTED_MODULE_7__tracking__["c" /* UserActionType */].CLICK, elementName, _pageKey, _metadata);
            }
          default:
            return null;
        }
      }
      if (dataType === 'apiType') {
        var headers = {
          'ic-merchant-key': merchantKey,
          'ic-origin': postMessageOrigin,
          'ic-merchant-sdk-scope': icScope
        };
        _this.props.widgetAction(__WEBPACK_IMPORTED_MODULE_6__actions_widgetAction_actionType__["a" /* default */].storeHeader, headers);
        /**
         * If else condition Added to make sure that previous version will also support the communication
         * TODO: Remove the else condition after caching related
         * issue won't be there and also remove `this.getData` methods
         */
        if (requestName) {
          _this.handleAPIRequest(requestName, request, { headers: headers }, postMessageOrigin);
        } else {
          _this.sendDataToParents({
            responseType: 'apiResponse',
            apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].INITIATED,
            response: {}
          }, postMessageOrigin);
          _this.getData(null, Object(__WEBPACK_IMPORTED_MODULE_3__components_material_ui_helper__["a" /* removeBlankKeys */])(request), { headers: headers }).then(function (resp) {
            _this.sendDataToParents({
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].SUCCESS,
              response: resp
            }, postMessageOrigin);
          }).catch(function (error) {
            _this.sendDataToParents({
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].ERROR,
              response: error
            }, postMessageOrigin);
          });
        }
      }
    }, _this.handleAPIRequest = function (requestName, requestData, header, postMessageOrigin) {
      _this.sendDataToParents({
        requestName: requestName,
        responseType: 'apiResponse',
        apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].INITIATED,
        response: {}
      }, postMessageOrigin);
      switch (requestName) {
        case 'fetchWidgetConfig':
          return Object(__WEBPACK_IMPORTED_MODULE_8__api_controllers_widgetControllers__["d" /* fetchWidgetConfig */])(header).then(function (resp) {
            _this.sendDataToParents({
              requestName: requestName,
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].SUCCESS,
              response: resp
            }, postMessageOrigin);
          }).catch(function (error) {
            _this.sendDataToParents({
              requestName: requestName,
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].ERROR,
              response: error
            }, postMessageOrigin);
          });

        case 'checkUserEligibility':
          var mobile = requestData.mobile,
              amount = requestData.amount,
              isCardEmiEnabled = requestData.isCardEmiEnabled,
              productWidgetHeader = requestData.productWidgetHeader;

          if (header && header.headers && productWidgetHeader) {
            header.headers[__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* PRODUCT_WIDGET_AUTH_HEADER_NAME */]] = productWidgetHeader;
          }
          var cookieDisabled = false;
          try {
            if (!navigator.cookieEnabled) {
              cookieDisabled = true;
            }
          } catch (e) {}

          return Object(__WEBPACK_IMPORTED_MODULE_8__api_controllers_widgetControllers__["c" /* fetchUserEligibleEMI */])({ mobile: mobile, amount: amount, isCardEmiEnabled: isCardEmiEnabled }, null, header).then(function (resp) {
            if (resp && resp.data && resp.data.mobile) {
              //creating a profile for user
              __WEBPACK_IMPORTED_MODULE_7__tracking__["e" /* tracker */].pushUserProfile();
            }

            var _ref5 = resp.data || {},
                responseICHeaders = _ref5.responseICHeaders;

            var productWidgetHeader = responseICHeaders && responseICHeaders[__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* PRODUCT_WIDGET_AUTH_HEADER_NAME */]];
            if (productWidgetHeader) {
              delete resp.data.responseICHeaders;
              if (productWidgetHeader) {
                resp.data.productWidgetHeader = productWidgetHeader;
              }
            }
            _this.sendDataToParents({
              requestName: requestName,
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].SUCCESS,
              response: resp
            }, postMessageOrigin);
          }).catch(function (error) {
            _this.sendDataToParents({
              requestName: requestName,
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].ERROR,
              response: error
            }, postMessageOrigin);
          });
        case 'widgetNonLoggedInExperiment':
          var clientId = __WEBPACK_IMPORTED_MODULE_9__utils__["c" /* default */].getCookie(__WEBPACK_IMPORTED_MODULE_10__tracking_helper__["a" /* CLIENT_ID_COOKIE_KEY */]) || Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getLocalstorage */])(__WEBPACK_IMPORTED_MODULE_10__tracking_helper__["a" /* CLIENT_ID_COOKIE_KEY */]);
          var data = {
            experimentName: __WEBPACK_IMPORTED_MODULE_11__api_controllers_experimentController__["a" /* experimentName */].WIDGET_NL_VARIANT,
            uniqueId: clientId
          };
          return Object(__WEBPACK_IMPORTED_MODULE_11__api_controllers_experimentController__["b" /* fetchExperimentData */])(data, null, header).then(function (resp) {
            _this.sendDataToParents({
              requestName: requestName,
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].SUCCESS,
              response: resp,
              experimentName: __WEBPACK_IMPORTED_MODULE_11__api_controllers_experimentController__["a" /* experimentName */].WIDGET_NL_VARIANT
            }, postMessageOrigin);
          }).catch(function () {
            _this.sendDataToParents({
              requestName: requestName,
              responseType: 'apiResponse',
              apiStatus: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* apiStatus */].SUCCESS,
              response: { data: { value: 'A' } }, //making sure in case of error we are getting 'A' variant only
              experimentName: __WEBPACK_IMPORTED_MODULE_11__api_controllers_experimentController__["a" /* experimentName */].WIDGET_NL_VARIANT
            }, postMessageOrigin);
          });
        default:
          return null;
      }
    }, _this.sendDataToParents = function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var postMessageOrigin = arguments[1];

      var validParentMerchantUrl = Object(__WEBPACK_IMPORTED_MODULE_12__utils_merchantOriginHelper__["a" /* getValidParentMerchantUrl */])(postMessageOrigin);
      window.parent.postMessage(JSON.stringify(data), validParentMerchantUrl);
    }, _this.getData = function (query, request, header) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__api_services_requestService__["a" /* default */])(query, request, function (d) {
        return d.data;
      }, null, null, header);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  WidgetCommunicationScreen.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('message', this.handleIframeTask);
  };

  WidgetCommunicationScreen.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('message', this.handleIframeTask);
  };

  WidgetCommunicationScreen.prototype.render = function render() {
    return null;
  };

  return WidgetCommunicationScreen;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, { widgetAction: __WEBPACK_IMPORTED_MODULE_5__actions_widgetAction__["a" /* default */] })(WidgetCommunicationScreen));

/***/ }),

/***/ "Yfrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchEMIInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchHowToBuy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchUserEligibleEMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchWidgetConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_end_points_be_endpoints__ = __webpack_require__("jM2E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_requestService__ = __webpack_require__("q4YJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_material_ui_helper__ = __webpack_require__("Ahxv");




var fetchEMIInfo = function fetchEMIInfo(data, query) {
  var request = {
    method: 'post',
    url: '' + __WEBPACK_IMPORTED_MODULE_0__services_end_points_be_endpoints__["a" /* default */].GET_EMI_INFO,
    data: data
  };
  return Object(__WEBPACK_IMPORTED_MODULE_1__services_requestService__["a" /* default */])(query, request, function (d) {
    return d;
  });
};

var fetchHowToBuy = function fetchHowToBuy(query) {
  var request = {
    method: 'get',
    url: __WEBPACK_IMPORTED_MODULE_0__services_end_points_be_endpoints__["a" /* default */].GET_HOW_TO_BUY_WIDGET
  };
  return Object(__WEBPACK_IMPORTED_MODULE_1__services_requestService__["a" /* default */])(query, request, function (d) {
    return d.data;
  });
};

var fetchUserEligibleEMI = function fetchUserEligibleEMI(_ref, query, overrideHeaders) {
  var mobile = _ref.mobile,
      amount = _ref.amount,
      isCardEmiEnabled = _ref.isCardEmiEnabled;

  var payLoad = isCardEmiEnabled || isCardEmiEnabled === undefined ? { mobile: mobile, amount: amount } : { mobile: mobile, amount: amount, creditSchemeType: 'CARDLESS' };
  var request = {
    method: 'post',
    url: __WEBPACK_IMPORTED_MODULE_0__services_end_points_be_endpoints__["a" /* default */].POST_CHECK_USER_ELIGIBLE_EMI,
    data: Object(__WEBPACK_IMPORTED_MODULE_2__components_material_ui_helper__["a" /* removeBlankKeys */])(payLoad)
  };

  var responseDecorator = function responseDecorator(response) {
    var _ref2 = response || {},
        data = _ref2.data,
        headers = _ref2.headers;

    var _ref3 = data || {},
        success = _ref3.success;

    if (success) {
      if (headers) {
        var icHeaders = {};
        Object.keys(headers).forEach(function (headerName) {
          if (/^ic-/.test(headerName)) {
            icHeaders[headerName] = headers[headerName];
          }
        });
        if (data && data.data) data.data['responseICHeaders'] = icHeaders;
      }
    }
    return { data: data };
  };
  return Object(__WEBPACK_IMPORTED_MODULE_1__services_requestService__["a" /* default */])(query, request, function (d) {
    return d.data;
  }, null, responseDecorator, overrideHeaders);
};

var fetchWidgetConfig = function fetchWidgetConfig(overrideHeaders) {
  var request = {
    method: 'get',
    url: __WEBPACK_IMPORTED_MODULE_0__services_end_points_be_endpoints__["a" /* default */].WIDGET_CONFIG
  };
  return Object(__WEBPACK_IMPORTED_MODULE_1__services_requestService__["a" /* default */])(null, request, function (d) {
    return d.data;
  }, null, null, overrideHeaders);
};

/***/ })

});


// WEBPACK FOOTER //
// route-widget-communication-screen.chunk.aa016.js